import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _Object$freeze from '@babel/runtime-corejs3/core-js-stable/object/freeze';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import 'core-js/modules/es.function.name';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Map from '@babel/runtime-corejs3/core-js-stable/map';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.to-string';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _toArray from '@babel/runtime-corejs3/helpers/toArray';
import _createForOfIteratorHelper from '@babel/runtime-corejs3/helpers/createForOfIteratorHelper';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';

var appConfig;
function setAppConfig(config) {
  var _context;

  if (_includesInstanceProperty(_context = [undefined, null, '', 0, false, NaN]).call(_context, config)) {
    throw new Error('setAppConfig invalid config type');
  }

  if (appConfig) {
    throw new Error('AppConfig already defined');
  }

  appConfig = _Object$freeze(_objectSpread({}, config));
}
function getAppConfig() {
  if (!appConfig) {
    throw new Error('AppConfig not defined');
  }

  return appConfig;
}

var libraryRegistry = new _Map();
function registerLibrary(library) {
  if (libraryRegistry.has(library.name)) {
    var _context, _context2;

    var registered = libraryRegistry.get(library.name);
    console.error(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "Library ".concat(library.name, " is already registered with version ")).call(_context2, registered.version, ". You are trying to register with version ")).call(_context, library.version));
  }

  libraryRegistry.set(library.name, _Object$freeze(_objectSpread({}, library)));
}
function getLibraries() {
  return new _Map(libraryRegistry);
}
function getLibrary(name) {
  return libraryRegistry.get(name);
}

var base = new _URL(document.baseURI || window.location.href || '');
var subscribers = new _Set();

function onURLChange(newUrl) {
  var _iterator = _createForOfIteratorHelper(subscribers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var iterator = _step.value;
      iterator(newUrl);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var handler = {
  apply: function apply(target, thisArg, args) {
    if (args[2] && args[2] !== window.location.pathname) {
      onURLChange(args[2]);
    }

    return target.apply(thisArg, args);
  }
};
window.history.pushState = new Proxy(window.history.pushState, handler);
window.history.replaceState = new Proxy(window.history.replaceState, handler);
window.addEventListener('hashchange', function (event) {
  var _context;

  var _getAppConfig = getAppConfig(),
      urlSeparator = _getAppConfig.urlSeparator;

  onURLChange((event.newURL || window.location.hash).replace(_concatInstanceProperty(_context = "".concat(base.toString())).call(_context, urlSeparator), ''));
});
function subscribe(fn) {
  subscribers.add(fn);
  return function () {
    return subscribers.delete(fn);
  };
}
function unsubscribe(fn) {
  if (subscribers.has(fn)) {
    subscribers.delete(fn);
  }
}
function getCurrentApplicationURL() {
  var _getAppConfig2 = getAppConfig(),
      urlSeparator = _getAppConfig2.urlSeparator;

  if (urlSeparator) {
    var _window$location$href = window.location.href.split(urlSeparator),
        _window$location$href2 = _toArray(_window$location$href),
        _url = _sliceInstanceProperty(_window$location$href2).call(_window$location$href2, 1);

    return _url.join(urlSeparator);
  }

  var _URL2 = new _URL(window.location.href),
      pathname = _URL2.pathname;

  return pathname;
}

var name = "@onviobr/app-info";
var version = "1.6.1";
registerLibrary({
  name: name,
  version: version
});

export { getAppConfig, getCurrentApplicationURL, getLibraries, getLibrary, registerLibrary, setAppConfig, subscribe as subscribeURLChange, unsubscribe as unsubscribeURLChange };
